export const light = {
  50: "#6D5A87",
  100: "#815B84",
  200: "#012C3D",
  300: "#44808B",
  400: "#40916C", //green
  500: "#F4ECEB",
  600: "#815B84",
  700: "#e9dcda",
  800: "#ae3570",
  900: "#384B5A"
};
export const dark = {
  50: "#f6e9cd",
  100: "#f0fabc",
  200: "#f3cb9b",
  300: "#2c8a86",
  400: "#822853",
  500: "#00131a",
  600: "#f0fabc",
  700: "#011a25",
  800: "#52b788", //green
  900: "#ae3570"
};

// *{
//   /* DARKMODE PALETTE */
//     --champagne: #f6e9cd;
//     --cream: #f0fabc;
//     --sunset: #f3cb9b;
//     --dark-cyan: #2c8a86;
//     --magenta-haze: #ae3570;

//     /* LIGHTMODE PALETTE */
//     --ultra-violet: #6D5A87ff;
//       --chinese-violet: #815B84ff;
//       --prussian-blue: #012C3Dff;
//       --teal: #44808Bff;
//       --charcoal: #384B5Aff;
// }